import { render } from "./LinkSidebar.vue?vue&type=template&id=797ff9e5&scoped=true"
import script from "./LinkSidebar.vue?vue&type=script&lang=js"
export * from "./LinkSidebar.vue?vue&type=script&lang=js"

import "./LinkSidebar.vue?vue&type=style&index=0&id=797ff9e5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-797ff9e5"]])

export default __exports__